module.exports = __webpack_public_path__ + "img/menu_bottom_9.7844f42b.svg";